var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepChampIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 233 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.082 229.829C180.557 229.829 232.015 178.417 232.015 114.997C232.015 51.5766 180.557 0.165039 117.082 0.165039C53.606 0.165039 2.14844 51.5766 2.14844 114.997C2.14844 178.417 53.606 229.829 117.082 229.829Z",
    fill: "#D6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1636 165.625L36.2226 196.556C36.3067 196.878 36.4536 197.18 36.6547 197.445C36.8559 197.709 37.1074 197.932 37.3948 198.099C37.6822 198.267 37.9998 198.376 38.3295 198.42C38.6591 198.464 38.9943 198.443 39.3157 198.358L132.817 173.968C133.464 173.798 134.017 173.378 134.354 172.801C134.692 172.224 134.787 171.536 134.619 170.889C134.477 170.335 134.152 169.844 133.696 169.499C133.24 169.154 132.679 168.973 132.107 168.988C104.44 169.981 63.9041 185.148 32.0654 162.944C31.6455 162.639 31.1413 162.471 30.6222 162.464C30.1032 162.458 29.5948 162.612 29.167 162.906C28.7392 163.2 28.4131 163.619 28.2334 164.106C28.0537 164.593 28.0293 165.124 28.1636 165.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.659 198.534L133.485 173.799C134.47 173.542 135.061 172.534 134.804 171.548L100.861 41.4256C100.604 40.4399 99.5964 39.8493 98.6107 40.1064L3.7849 64.842C2.7992 65.0991 2.20857 66.1067 2.4657 67.0924L36.4087 197.215C36.6658 198.201 37.6733 198.792 38.659 198.534Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3762 162.986C63.6692 162.986 64.7173 161.938 64.7173 160.645C64.7173 159.352 63.6692 158.304 62.3762 158.304C61.0833 158.304 60.0352 159.352 60.0352 160.645C60.0352 161.938 61.0833 162.986 62.3762 162.986Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7329 174.706C54.3844 174.706 57.3446 171.746 57.3446 168.094C57.3446 164.443 54.3844 161.482 50.7329 161.482C47.0813 161.482 44.1211 164.443 44.1211 168.094C44.1211 171.746 47.0813 174.706 50.7329 174.706Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1636 165.625L36.2226 196.556C36.3067 196.878 36.4536 197.18 36.6547 197.445C36.8559 197.709 37.1074 197.932 37.3948 198.099C37.6822 198.267 37.9998 198.376 38.3295 198.42C38.6591 198.464 38.9943 198.443 39.3157 198.358L132.817 173.968C133.464 173.798 134.017 173.378 134.354 172.801C134.692 172.224 134.787 171.536 134.619 170.889C134.477 170.335 134.152 169.844 133.696 169.499C133.24 169.154 132.679 168.973 132.107 168.988C104.44 169.981 63.9041 185.148 32.0654 162.944C31.6455 162.639 31.1413 162.471 30.6222 162.464C30.1032 162.458 29.5948 162.612 29.167 162.906C28.7392 163.2 28.4131 163.619 28.2334 164.106C28.0537 164.593 28.0293 165.124 28.1636 165.625Z",
    fill: "#DBCEC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.659 198.534L133.485 173.799C134.47 173.542 135.061 172.534 134.804 171.548L100.861 41.4256C100.604 40.4399 99.5964 39.8493 98.6107 40.1064L3.7849 64.842C2.7992 65.0991 2.20857 66.1067 2.4657 67.0924L36.4087 197.215C36.6658 198.201 37.6733 198.792 38.659 198.534Z",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4829 162.702C63.7053 162.702 64.6963 161.711 64.6963 160.489C64.6963 159.266 63.7053 158.275 62.4829 158.275C61.2605 158.275 60.2695 159.266 60.2695 160.489C60.2695 161.711 61.2605 162.702 62.4829 162.702Z",
    fill: "#DBCEC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5021 173.741C54.9421 173.741 57.7308 170.952 57.7308 167.512C57.7308 164.072 54.9421 161.284 51.5021 161.284C48.0621 161.284 45.2734 164.072 45.2734 167.512C45.2734 170.952 48.0621 173.741 51.5021 173.741Z",
    fill: "#DBCEC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3767 69.1584L33.957 83.517",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.907 80.2964L67.4531 86.4116",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.402 107.055L136.638 107.708",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.668 163.185V28.0691H84.1992V193.874H185.703L215.668 163.185Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.013 25.5859V160.702L184.033 191.391H165.418L203.017 153.792V25.5859H214.013Z",
    fill: "#DBCEC8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.932 71.4997C205.991 71.4997 209.281 68.2091 209.281 64.1501C209.281 60.091 205.991 56.8005 201.932 56.8005C197.873 56.8005 194.582 60.091 194.582 64.1501C194.582 68.2091 197.873 71.4997 201.932 71.4997Z",
    fill: "#DBCEC8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M188.824 61.284C190.634 61.284 192.102 59.8166 192.102 58.0065C192.102 56.1964 190.634 54.729 188.824 54.729C187.014 54.729 185.547 56.1964 185.547 58.0065C185.547 59.8166 187.014 61.284 188.824 61.284Z",
    fill: "#DBCEC8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.223 162.078V26.9626H84.7539V192.768H186.243L216.223 162.078Z",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.543 26.4091V23.7843C103.543 19.8632 105.101 16.1028 107.873 13.3302C110.646 10.5576 114.406 9.00001 118.327 9.00001C120.269 8.99814 122.193 9.37927 123.987 10.1216C125.782 10.8639 127.412 11.9528 128.785 13.3261C130.159 14.6993 131.248 16.3298 131.99 18.1244C132.732 19.9189 133.113 21.8422 133.111 23.7843V59.0139C133.111 60.756 132.768 62.4811 132.102 64.0906C131.435 65.7001 130.458 67.1626 129.226 68.3945C127.994 69.6263 126.532 70.6035 124.922 71.2702C123.313 71.9369 121.587 72.28 119.845 72.28C116.327 72.28 112.953 70.8823 110.465 68.3945C107.977 65.9066 106.579 62.5323 106.579 59.0139V49.3375",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.785 95.8752H177.868",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.785 110.092H142.397",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.785 124.153H166.518",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepChampIcon);
export default __webpack_public_path__ + "static/media/prep-champ-icon.2e6fc943feba78809460e3d9c0bbad5d.svg";
export { ForwardRef as ReactComponent };